import { HelperFunctions } from "utility/helperFunctions";

const environment = {
	apiUrl: "", // <base url to api server, e.g. https://localhost:5000>
	captchaSiteKey: "", // <google captcha site key>
	azureTenantId: "", // <azure app tenantId, e.g. eXXXX-XXXX>
	azureClientId: "", // <azure app clientId, e.g. 1XXXX-XXXX>
	blobStorageUrl: "", // <base url to blob storage, e.g. https://devscmstorage.blob.core.windows.net:443/scmdev>
	documentAttachmentSize: 0, // <max document size(MB), e.g. 5MB>
	takeOnImportFunctionUrl: "", // <base url to take on import azure function>
	buildTarget: process.env.REACT_APP_BUILD_TARGET || "internal",
};

// Environment base runtime configuration *************************************
const { runConfig } = window as any;
if (runConfig) {
	Object.assign(environment, runConfig);
}
HelperFunctions.mergeObj(environment, runConfig);

export default environment;
